const mutations = {
  SET_DRAWER_FLAG(state, { flag }) {
    state.showFlag = flag
  },
  SET_DRAWER_TYPE(state, { type }) {
    state.drawerType = type
  },
  SET_DRAWER_TOGGLE_BUTTON_VISIBILITY(state, { flag }) {
    state.toggleButton = flag
  },
}

export default mutations
